/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import * as Utilities from '../utilities';
import { FormHeader } from '../../react/form_header.jsx';
import { FormThemeContext } from '../../react/form_theme_context.js.jsx';
import { FormInputGroup } from '../../react/form_input_group.jsx';

import * as Actions from '../store/actions';
import { FormRow } from '../../react/form_row.jsx';

export class TicketGroupForm extends React.Component {
        constructor(...args) {
          super(...args);
          this.onInputChange = this.onInputChange.bind(this);
          this.inputChanged = this.inputChanged.bind(this);
this.isValid = this.isValid.bind(this);
        }

        static initClass() {
          this.contextType = FormThemeContext;
  
          this.propTypes = {
            ticketGroup: Actions.TicketGroupShape,
            // Callback when an input field changes
            onChange: PropTypes.func,
            // Callback for the "Update" button, which just closes the editor
            onClose: PropTypes.func
          };
        }

        onInputChange(event, name, value) {
          const field_name = (name != null) ? name : event.target.name;
          const field_value = (value != null) ? value : event.target.type === 'checkbox' ? event.target.checked : event.target.value;
          return (typeof this.props.onChange === 'function' ? this.props.onChange(field_name, field_value, event) : undefined);
        }

        // Returns a callback function to call onInputChange with the specified name
        inputChanged(name) {
          return event => this.onInputChange(event, name);
        }

        isValid() {
          if (this.props.ticketGroup.name.isBlank()) { return false; }
          return true;
        }

        render() {
          const input_id = `ticket-group-name-${this.props.ticketGroup.id}`;

          return <tr>
            <td className="edit-form" colSpan="5">
              <FormInputGroup>
                <FormRow title="Name"
                         labelFor={input_id}
                         required
                         {...this.context.textInputRow}>
                  <input name="name"
                         id={input_id}
                         type="text"
                         className={this.context.textInputRow.inputClassName}
                         value={this.props.ticketGroup.name}
                         onChange={this.onInputChange}
                         autoFocus />
                </FormRow>

              </FormInputGroup>

              <div className="action-button pull-right">
                <button className="btn-color"
                        disabled={!this.isValid()}
                        onClick={this.props.onClose}>
                  Save Ticket Type
                </button>
              </div>
            </td>
          </tr>;
        }
      }
TicketGroupForm.initClass();
